export default "__VITE_ASSET__CyljMUDi__"